module.exports = __webpack_public_path__ + "img/zhewan2.d48edd17.png";